import type { Map as MapLibreMap } from 'maplibre-gl';
import { useMapEvent } from './useMapEvent';

export interface MapView {
  lat: number;
  lng: number;
  zoom: number;
}

/** Initial camera from `?lat=&lng=&zoom=`, falling back to `defaults`. */
export function readUrlView(defaults: MapView): MapView {
  const params = new URLSearchParams(location.search);
  const num = (key: string, fallback: number) => Number(params.get(key) ?? fallback);
  return { lat: num('lat', defaults.lat), lng: num('lng', defaults.lng), zoom: num('zoom', defaults.zoom) };
}

function writeUrlView(map: MapLibreMap) {
  const c = map.getCenter();
  history.replaceState(
    null,
    '',
    `?lat=${c.lat.toFixed(5)}&lng=${c.lng.toFixed(5)}&zoom=${map.getZoom().toFixed(2)}`,
  );
}

/** Keeps the URL in sync with the camera so the view can be shared or reloaded. */
export function UrlViewSync() {
  useMapEvent('moveend', (e) => writeUrlView(e.target));
  return null;
}
